import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import moment from "moment";
import exportFromBlob from "helpers/export-from-blob";
import { requestGetReportContacts } from "actions/draftActions";

class DownloadContactsButton extends React.PureComponent {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick = () => {
        this.props.requestGetReportContacts((contactsReport) => {
            const fileName = `contacts-report-${moment().format("YYYY-MM-DD")}.xlsx`;
            exportFromBlob(contactsReport, fileName);
        });
    };

    render() {
        const {
            className,
            title
        } = this.props;

        return (
            <button
                className={className}
                onClick={this.handleClick}
            >
                {title}
            </button>
        );
    }
}

DownloadContactsButton.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
};

const mapStateToDispatch = dispatch => ({
    requestGetReportContacts: bindActionCreators(requestGetReportContacts, dispatch),
});

export default connect(
    null,
    mapStateToDispatch
)(DownloadContactsButton);
